import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.scss'],
})
export class SetupComponent {
  assess1:boolean;
  loader:boolean = false;
  id;
  constructor( private service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public auth: AuthService) { }


    ionViewWillEnter(){
      sessionStorage.setItem('vendorApp','true');
    }

}